var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{attrs:{"label":_vm.$t('dark'),"hide-details":""},model:{value:(_vm.isDarkTheme),callback:function ($$v) {_vm.isDarkTheme=$$v},expression:"isDarkTheme"}})
}
var staticRenderFns = []

export { render, staticRenderFns }